import { getJSON } from 'common/util/request'

export const getSettings = () => {
    return getJSON('settings')
}

export default getSettings
